import { useState, useEffect } from 'react';
import { OperationMS } from '../types';
import { CommandeAnalyse, CritereKey, CritereNote, TechNotes } from '../domain/analyse/types';
import { seedTechNotesFromCommandes } from '../domain/analyse/notationTechnique';

// Buffer editable des notes techniques, keye par String(commande.id). Seed depuis l'API au
// (re)chargement de l'operation ; pas de reseed tant que l'operation n'est pas refetchee.
export const useNotesTechniques = (operation: OperationMS | null) => {
  const [techNotes, setTechNotes] = useState<TechNotes>({});

  useEffect(() => {
    if (!operation) return;
    setTechNotes(seedTechNotesFromCommandes((operation.commandes ?? []) as CommandeAnalyse[]));
  }, [operation]);

  const setNote = (
    commandeId: number | string,
    critere: CritereKey,
    patch: Partial<CritereNote>,
  ): void => {
    const key = String(commandeId);
    setTechNotes((prev) => ({
      ...prev,
      [key]: {
        ...prev[key],
        [critere]: { ...prev[key]?.[critere], ...patch },
      },
    }));
  };

  return { techNotes, setTechNotes, setNote };
};
